import * as React from 'react'
import { EntityLocationsListViewProps } from '../typings'
import { useCheckPermissions } from '@user/store/authorization'
import { LocationsPopoverButton } from '..'

export const LocationsListViewWrapper: React.FC<
  EntityLocationsListViewProps
> = (props) => {
  const { row, field, listViewValue, entityType } = props

  const [canUpdateLeads] = useCheckPermissions('leads_update')

  return (
    <LocationsPopoverButton
      entityId={row.id}
      entityType={entityType}
      entityBranchId={row.branchId}
      matched={row.externalLocationCode !== null}
      canUpdateEntity={canUpdateLeads}
      isListView
      field={field}
      listViewValue={listViewValue}
      variant="entity"
    />
  )
}
LocationsListViewWrapper.displayName = 'LocationsListViewWrapper'
